<template>
  <nav-bar class="mainbar">
    <div slot="left" @click="tohome()">
      <img src="~assets/logo.svg" alt="">
    </div>
    <div slot="center" class="navbar" :style="{'display': this.$route.query.query ? 'none':'flex'}">
       <el-row type="flex" :gutter="40">
        <el-col
          v-for="(item, index) in navItem"
          :key="index"
          :style="{ 'min-width': index === 7 ? 120 + 'px' : 120 + 'px' }"
        >
          <a
            :href="item.path"
            @click="itemClick(item.path, index)"
            :style="{
              'border-bottom':
                currentIndex === index ? '2px solid  #0089CE' : '',
              color: currentIndex === index ? '#0089CE' : '',
            }"
            class="nav"
            >{{ item.name }}</a
          >
        </el-col>
      </el-row>
    </div>
    <div slot="right" :style="searchnow" @keyup.enter="searchs()">
      <el-input placeholder="请输入内容" v-model="search" class="input-with-select" :class="{active: type}" clearable @focus="handleFocus" >
        <el-button slot="append" icon="el-icon-search" @click="searchs()" ></el-button>
      </el-input>
    </div>
  </nav-bar>
</template>

<script>
import NavBar from 'components/common/navbar/NavBar'
import { Encrypt, Decrypt } from '@/util/EncryptionToDecrypt'
// import NavBarItem from 'components/common/navbaritem/NavBarItem'
export default {
  name: 'MainNavBar',
  components: {
    NavBar
    // NavBarItem
  },
  data () {
    return {
      search: '',
      currentIndex: 0,
      type: false,
      navItem: [
        {
          name: '首页',
          path: '/'
        },
        // {
        //   name: '疾病',
        //   path: '/disease'
        // },
        // {
        //   name: '课程',
        //   path: '/mobVideoCenter'
        // },
        // {
        //   name: '语音',
        //   path: '/mobAudioCenter'
        // },
        {
          name: '文章',
          path: '/mobArticleCenter'
        },
        {
          name: '答疑',
          path: '/mobQuestionCenter'
        },
        {
          name: '医生',
          path: '/mobVideoDoctorMore'
        },
        {
          name: '关于我们',
          path: '/moreservice'
        }
      ]
    }
  },
  computed: {
    searchnow () {
      // // console.log(this.$route.query.index)
      if (this.$route.query.query) {
        return { width: 656 + 'px' }
      }
      return {}
    }
  },
  watch: {
    $route: function (newVal) {
      this.search = newVal.path === '/mobSearch' ? (Decrypt(this.$route.query.query) ? Decrypt(this.$route.query.query) : '') : ''
      // this.currentIndex = Number(sessionStorage.getItem('nav'))
      console.log(newVal.path)
      if (newVal.path === '/disease') {
        this.currentIndex = 1
      // } else if (newVal.path.indexOf('/video') !== -1) {
      } else if (newVal.path === '/disease/diseasedetail') {
        this.currentIndex = 1
      } else if (newVal.path === '/mobVideoCenterDel') {
        this.currentIndex = 1
      } else if (newVal.path === '/mobVideoCenter') {
        this.currentIndex = 1
      } else if (newVal.path === '/mobAudioCenter') {
        this.currentIndex = 2
      } else if (newVal.path === '/mobVideoCenterAudioDel') {
        this.currentIndex = 2
      } else if (newVal.path === '/mobArticleCenter') {
        this.currentIndex = 1
      } else if (newVal.path === '/mobVideoCenterArticleDel') {
        this.currentIndex = 1
      } else if (newVal.path === '/mobQuestionCenter') {
        this.currentIndex = 2
      } else if (newVal.path.indexOf('/mobQuestionCenterDel') !== -1) {
        this.currentIndex = 2
      } else if (newVal.path === '/mobVideoDoctorMore') {
        this.currentIndex = 3
      } else if (newVal.path === '/mobVideoCenterHome') {
        this.currentIndex = 3
      } else if (newVal.path === '/mobDoctorIndex') {
        this.currentIndex = 3
      } else if (newVal.path === '/moreservice') {
        this.currentIndex = 4
      } else {
        this.currentIndex = 0
      }
    },
    immediate: true,
    deep: true
  },
  methods: {
    searchs () {
      if (this.search === '') {
        this.type = true
      } else {
        this.type = false
        this.$router.push({ path: '/mobSearch', query: { query: Encrypt(this.search) } })
      }
    },
    handleFocus () {
      this.type = false
    },
    tohome () {
      this.currentIndex = 0
      this.$router.push({ path: '/' })
    },
    itemClick (e, index) {
      // // sessionStorage.setItem('nav', index)
      this.currentIndex = index
      this.$router.push(e)
    }
  }
}
</script>

<style scoped>
.mainbar{
  height: 100px;
  position: fixed;
  background-color: #FFFFFF;
  z-index: 999;
}
nav-bar{
  height: 100px;
}
.nav{
  cursor: pointer;
}
img{
  line-height: 100px;
  width: 199px;
  height: 48px;
}
.navbar{
  display: flex;
  padding-right: 40px;
}
.navbar nav-bar-item{
  width: 32px;
  height: 24px;
  line-height: 24px;
}
.active{
  border: 1px solid red;
}
a{
  cursor: pointer;
  text-decoration: none;
  color: black;
}
</style>
